import { useSpeckleAuthStore } from '@haskoning/vue-speckle'
import { defineStore } from 'pinia'
import { computed, ref, watch } from 'vue'

export const useSpeckleSsoStore = defineStore('speckleSSO', () => {
  const speckleAuthStore = useSpeckleAuthStore()
  const isActive = ref(false)
  const ssoReauthenticationRequired = ref(false)
  speckleAuthStore.isAuthenticated
  watch(
    () => speckleAuthStore.isAuthenticated,
    async (newVal) => {
      if (!newVal) {
        return
      }
      if (isActive.value) {
        return
      }
      try {
        isActive.value = true
        const isValid = await speckleAuthStore.checkSsoSessionValidity()
        ssoReauthenticationRequired.value = !isValid
      } finally {
        isActive.value = false
      }
    },
    { immediate: true }
  )

  const canUseSpeckle = computed(() => {
    return !!speckleAuthStore.isAuthenticated && !ssoReauthenticationRequired.value
  })

  return {
    ssoReauthenticationRequired,
    canUseSpeckle
  }
})
